
define('text!modules/targeting/contextual/templates/bin_title.html',[],function () { return '<div class="header-c title">Contextual: <span class="count" data-bind="{{bin_action}}-count"></span><div class="icon-spinner"></div></div>';});

